export const ScreenshotIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 9C6.5 9.66304 6.76339 10.2989 7.23223 10.7678C7.70107 11.2366 8.33696 11.5 9 11.5C9.66304 11.5 10.2989 11.2366 10.7678 10.7678C11.2366 10.2989 11.5 9.66304 11.5 9C11.5 8.33696 11.2366 7.70107 10.7678 7.23223C10.2989 6.76339 9.66304 6.5 9 6.5C8.33696 6.5 7.70107 6.76339 7.23223 7.23223C6.76339 7.70107 6.5 8.33696 6.5 9Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 4V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 4V2.5C16.5 2.23478 16.3946 1.98043 16.2071 1.79289C16.0196 1.60536 15.7652 1.5 15.5 1.5H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 14V15.5C1.5 15.7652 1.60536 16.0196 1.79289 16.2071C1.98043 16.3946 2.23478 16.5 2.5 16.5H4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 14V15.5C16.5 15.7652 16.3946 16.0196 16.2071 16.2071C16.0196 16.3946 15.7652 16.5 15.5 16.5H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
